export default __webpack_public_path__ + "static/media/noun-heart-monitor.2f525ed8.svg";